// TODO API 응답 형태에 따라 Product로 통합 고려 ; src/v2-models/Product/Product.js:9

import { ofOrderDetailProductItem } from './OrderDetailProductItem'
import { ofOrderDetailOption } from './OrderDetailOption'

const OrderDetailProductType = Object.freeze({
  SINGLE: 'SINGLE',
  SET_THREE: 'SET_THREE',
  SET_FIVE: 'SET_FIVE',
  SET_SEVEN: 'SET_SEVEN'
})

const OrderDetailProduct = class {
  constructor({ productId, name, type, salePrice = 0, imageUrl, items = [], options = [], bundle, isBundle }) {
    this.productId = productId
    this.name = name
    this.type = type
    this.salePrice = salePrice
    this.imageUrl = imageUrl
    this.isBundle = isBundle
    this.bundle = bundle
    this.items = Array.isArray(items) ? items.map((e) => ofOrderDetailProductItem(e)) : []
    this.options = Array.isArray(options) ? options.map((e) => ofOrderDetailOption(e)) : []
  }

  get isFixedType() {
    return [
      OrderDetailProductType.SET_THREE,
      OrderDetailProductType.SET_FIVE,
      OrderDetailProductType.SET_SEVEN
    ].includes(this.type)
  }

  getOptions() {
    return this.options
  }
}

export default null

export const ofOrderDetailProduct = (params = {}) => new OrderDetailProduct(params)
